const keys = {
  claims: {
    actions: {
      add: 'Add loss',
      edit: 'Edit',
      remove: 'Remove',
    },
    car: {
      title: 'Please add all at-fault and not-at-fault accidents or losses.',
    },
    home: { title: 'Tell us about your most recent claims.' },

    fields: {
      claimDate: {
        home: 'Date of the claim',
        car: 'Date of the claim',
      },
      claimedAmount: 'Amount paid by insurer',
      claimDescription: 'Tell us what happended',
      responsible: {
        specificDriver: 'Was {{0}} responsible for the accident?',
        default: 'Were you responsible for the accident?',
      },
    },
    placeholders: {
      claimedAmount: 'ex. 4,000',
      claimDescription: {
        car: 'ex. Collision',
        home: 'ex. Flood water damage',
      },
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
